const role_hierarchy = {
    ROLE_SUPER_ADMIN: ['ROLE_ADMIN', 'ROLE_ALLOWED_TO_SWITCH'],
    ROLE_ADMIN: ['ROLE_GUEST_ADMIN'],
    ROLE_GUEST_ADMIN: ['ROLE_ADMIN_USER', 'ROLE_ORGANIZATION_ADMIN'],
    ROLE_ORGANIZATION_ADMIN: ['ROLE_ORGANIZATION_USER'],
    ROLE_ORGANIZATION_EDITOR: ['ROLE_CP_USER'],
    ROLE_ORGANIZATION_USER: ['ROLE_CP_USER'],
    ROLE_ADMIN_USER: ['ROLE_CP_USER'],
    ROLE_CP_USER: ['ROLE_USER'],
};

export const getRoles = (role) => {
    let roles = [role];
    let childRoles = role_hierarchy[role] || [];
    while (childRoles.length) {
        roles = [...roles, ...childRoles];
        childRoles = childRoles.reduce((acc, cur) => [...acc, ...(role_hierarchy[cur] || [])], [])
    }
    return [...new Set(roles)];
};